import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var printMq = '@media print';
  var getMainStylesByStatus = function getMainStylesByStatus() {
    switch (props.status) {
      case 'correct':
        return {
          border: "solid ".concat(componentTheme.mainCorrectBorder),
          borderColor: componentTheme.mainCorrectBorderColor
        };
      case 'incorrect':
        return {
          border: "solid ".concat(componentTheme.mainIncorrectBorder),
          borderColor: componentTheme.mainIncorrectBorderColor
        };
      case 'unknown':
        return {
          border: "solid ".concat(componentTheme.mainUnknownBorder),
          borderColor: componentTheme.mainUnknownBorderColor
        };
      default:
        return {
          borderColor: componentTheme.mainBackgroundColor
        };
    }
  };
  var getIconBackgroundByStatus = function getIconBackgroundByStatus() {
    var backgroundColors = {
      correct: componentTheme.iconCorrectBackgroundColor,
      incorrect: componentTheme.iconIncorrectBackgroundColor,
      unknown: componentTheme.iconUnknownBackgroundColor
    };
    return backgroundColors[props.status];
  };
  return {
    root: _defineProperty({
      margin: '0',
      display: 'flex',
      flexDirection: 'column'
    }, printMq, {
      colorAdjust: 'exact'
    }),
    main: _objectSpread({
      minHeight: '46px',
      width: '100%',
      borderRadius: componentTheme.mainBorderRadius,
      display: 'inline-flex'
    }, getMainStylesByStatus()),
    userResponse: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: componentTheme.userResponsePadding
    },
    iconHolder: {
      minWidth: '46px',
      maxWidth: '46px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative'
    },
    correctAnswer: {
      fontWeight: componentTheme.correctAnswerFontWeight,
      paddingLeft: componentTheme.correctAnswerPadding
    },
    subTitleDescription: {
      fontWeight: 'initial',
      verticalAlign: 'top'
    },
    subTitleContent: {
      display: 'inline-block'
    },
    icon: {
      height: '100%',
      width: '100%',
      color: componentTheme.iconColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: '0',
      backgroundColor: getIconBackgroundByStatus()
    },
    correctAnswerHolder: {
      minHeight: '1.5rem',
      fontSize: componentTheme.correctAnswerHolderFontSize,
      whiteSpace: 'initial',
      display: 'flex',
      alignItems: 'center'
    }
  };
};
export default generateStyle;